import { useQuery } from 'react-query';
import { APIErrorType } from '../../api';
import { UseQueryOptions, UseQueryResult } from 'react-query/types/react/types';
import { fetchVoices, VoiceType } from '../../api/voice';

export type useVoicesReturnType = UseQueryResult<VoiceType[]>;

export function useVoices(
  examId: number | undefined,
  options: Omit<
    UseQueryOptions<VoiceType[], APIErrorType, VoiceType[], [string, number]>,
    'queryKey | queryFn'
  > = {}
): useVoicesReturnType {
  if (!examId) throw Error('examId is undefiend');
  return useQuery<VoiceType[], APIErrorType, VoiceType[], [string, number]>(
    ['voices', examId],
    fetchVoices,
    {
      staleTime: 30 * 1000,
      retry: false,
      ...options
    }
  );
}
